import React from "react";

import { css, cx } from "@emotion/css";
import { Duration } from "luxon";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import type { PumpModeIndicators } from "@/models/PumpModeStatsModel.ts";
import { useTheme, type Theme } from "@/theme/CreateTheme.ts";
import { PumpModeStatItem } from "@/uiKit/organisms/DiabetesStats/PumpModeStatItem.tsx";

export type PumpModeBarKey = "auto" | "manual";

type PumpModeBarsProps = {
  pumpMode?: PumpModeIndicators;
  width?: number;
  height?: number;
  className?: string;
};

export const PumpModeBars: React.FC<PumpModeBarsProps> = ({ pumpMode, className }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useStyles(makeStyles);

  return (
    <div className={cx(styles.container, className)}>
      <PumpModeStatItem
        title={t("pumpMode.auto")}
        value={
          Duration.fromDurationLike({
            minutes: pumpMode?.auto.durationMinutes,
          }).shiftTo("hours").hours
        }
        unit={"h"}
        percentage={(pumpMode?.auto.percentage ?? 0) / 100}
        barColor={theme.palette.blue.light}
        barFillColor={theme.palette.blue.contrastText}
      />
      <PumpModeStatItem
        title={t("pumpMode.manual")}
        value={
          Duration.fromDurationLike({
            minutes: pumpMode?.manual.durationMinutes,
          }).shiftTo("hours").hours
        }
        unit={"h"}
        percentage={(pumpMode?.manual.percentage ?? 0) / 100}
        barColor={theme.palette.hyperglycemia.light}
        barFillColor={theme.palette.hyperglycemia.contrastText}
      />
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  }),
});
